import API from "../api/manager";
import config from "../api/config";
import APIV2 from "../api/managerV2";
import { EventEmitter } from "../helpers/Event";
import { SourcesStore } from "../store/store_state";

const getSkillDetail = (skillId, includeProficiencies) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.getSkillV3}/${skillId}/?includeProficiencies=${includeProficiencies}`,
    },
    true
  );
};

const getSkillDetailV3 = (id, bool) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.getSkillV3 + id,
    },
    true
  );
};

const addSkillDetail = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.getSkill,
      data,
    },
    true
  );
};

const addSkillDetailV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.getSkillV3,
      data,
    },
    true
  );
};

const createFamilyV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.familiesV3,
      data,
    },
    true
  );
};

const updateSkillDetail = (id, data) => {
  return API(
    {
      method: "PATCH",
      url: config.urls.auth.getSkill + id,
      data,
    },
    true
  );
};

const updateSkillDetailV3 = (id, data) => {
  return APIV2(
    {
      method: "PATCH",
      url: config.urls.auth.getSkillV3 + id,
      data,
    },
    true
  );
};

const deleteSkillDetail = (id) => {
  return API(
    {
      method: "DELETE",
      url: config.urls.auth.getSkill + id,
    },
    true
  );
};

const deleteSkillDetailV3 = (id) => {
  return APIV2(
    {
      method: "DELETE",
      url: config.urls.auth.getSkillV3 + id,
    },
    true
  );
};

const getSkillTypesArray = (id, type) => {
  return API(
    {
      method: "GET",
      url: config.urls.auth.getSkill + id + type,
    },
    true
  );
};

const getSkillTypesArrayV3 = (skillId, type) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.getSkillV3}/${skillId}/${type}`,
    },
    true
  );
};

const searchSkill = (data, params = "") => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.getSkill + "/search" + params,
      data,
    },
    true
  );
};

const SearchSkillTree = (searchString) => {
  return API(
    {
      method: "GET",
      url:
        "https://disprztechskillsapi.azurewebsites.net/TechSkills/search/" +
        searchString,
    },
    false
  );
};

const deleteSkillTypeItem = (id, type, itemId) => {
  return API(
    {
      method: "DELETE",
      url: config.urls.auth.getSkill + id + type + itemId,
    },
    true
  );
};

const deleteSkillTypeItemV3 = (id, type, itemId) => {
  return APIV2(
    {
      method: "DELETE",
      url: config.urls.auth.getSkillV3 + id + type + itemId,
    },
    true
  );
};

const updateProficiency = (id, type, itemId, data) => {
  return API(
    {
      method: "PATCH",
      url: config.urls.auth.getSkill + id + type + itemId,
      data,
    },
    true
  );
};

const updateProficiencyV3 = (id, type, itemId, data) => {
  return APIV2(
    {
      method: "PATCH",
      url: config.urls.auth.getSkillV3 + id + type + itemId,
      data,
    },
    true
  );
};

const addProficiency = (id, type, data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.getSkill + id + type,
      data,
    },
    true
  );
};

const addProficiencyV3 = (id, type, data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.getSkillV3 + id + type,
      data,
    },
    true
  );
};

const getSkillCategories = (mapping = "") => {
  return API(
    {
      method: "GET",
      url: config.urls.auth.skillCategories + mapping,
    },
    true
  );
};

const getSkillCategoriesV3 = (type = "persona") => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.skillCategoriesV3}${type !== "persona" ? `?mappingAsFunctional=${type === "industry"}&mappingAsLeadership=${type === "leader"}`: ""}`,
    },
    true
  );
};

const getSkillFamilies = () => {
  return API(
    {
      method: "GET",
      url: config.urls.auth.skillFamilies,
    },
    true
  );
};

const getSkillFamiliesV3 = (id = "") => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.skillFamiliesV3 + id,
    },
    true
  );
};

const getSkillSources = () => {
  return API(
    {
      method: "GET",
      url: config.urls.auth.skillSources,
    },
    true
  );
};

let sourcesRequest = null;

const getCachedSkillSources = (excludeRetired = false) => {
  const s = SourcesStore.getRawState()?.sources || [];
  if (s.length > 0) {
    return {
      value: [...(excludeRetired ? s.filter(src => src.isRetired !== 1) : s)]
    };
  }
  return null;
};

const getSkillSourcesV4 = async (excludeRetired = false) => {
  const cachedSources = getCachedSkillSources(excludeRetired);
  if (cachedSources) return cachedSources;

  if (!sourcesRequest) {
    SourcesStore.update((s) => {
      s.isLoading = true;
      s.error = null;
    });

    sourcesRequest = APIV2(
      {
        method: "GET",
        url: `${config.urls.auth.getSourcesV4}?excludeRetired=false`,
      },
      true
    )
      .then((res) => {
        const sources = res?.value || [];
        SourcesStore.update((s) => {
          s.sources = sources;
          s.isLoaded = true;
          s.error = null;
        });
        return { ...res, value: sources };
      })
      .catch((error) => {
        SourcesStore.update((s) => {
          s.error = error;
        });
        throw error;
      })
      .finally(() => {
        SourcesStore.update((s) => {
          s.isLoading = false;
        });
        sourcesRequest = null;
      });
  }

  const res = await sourcesRequest;
  return {
    ...res,
    value: excludeRetired
      ? (res?.value || []).filter((src) => src.isRetired !== 1)
      : [...(res?.value || [])],
  };
};

const getSkillProficiencyLevels = () => {
  return API(
    {
      method: "GET",
      url: config.urls.auth.skillProficiencyLevels,
    },
    true
  );
};

const getSkillProficiencyLevelsV3 = (sourceId) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.sourceV3}/${sourceId}/proficiency-levels`
    },
    true
  );
};

const getSkillContentItems = (
  skillId,
  type,
  pagesize = 10,
  offset,
  clientId = "",
  showIrrelevantCourses = false,
  sort = "",
  filter = ""
) => {
  return API(
    {
      method: "GET",
      url:
        config.urls.auth.getSkill +
        skillId +
        type +
        clientId +
        pagesize +
        offset +
        showIrrelevantCourses +
        sort +
        filter,
    },
    true
  );
};

const getSkillContentItemsV3 = (
  skillId,
  type,
  pagesize = 10,
  offset,
  clientId = "",
  showIrrelevantCourses = false,
  sort = "",
  filter = "",
  proficiencySchemeLevelCount
) => {
  return APIV2(
    {
      method: "GET",
      url:
        config.urls.auth.getSkillV3 +
        skillId +
        type +
        clientId +
        pagesize +
        offset +
        showIrrelevantCourses +
        sort +
        filter +
        proficiencySchemeLevelCount
    },
    true
  );
};

const updateSkillContentItem = (skillId, contentId, relevancy) => {
  return API(
    {
      method: "PATCH",
      url:
        config.urls.auth.getSkill +
        skillId +
        "/contentItems/" +
        contentId +
        `?relevancy=${relevancy}`,
    },
    true
  );
};

const bulkUpdateSkillContentItemV3 = (skillId, data, relevancy, isVectorBased) => {
    return APIV2(
        {
            method: "PATCH",
            url: `${config.urls.auth.getSkillV3}${skillId}/contentItems?relevancy=${relevancy}&isVectorBased=${isVectorBased}`,
            data
        },
        true
    );
};

const getSuggestedskills = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.getSuggestedskills,
      data,
    },
    true
  );
};

const getSuggestedskillsV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.getSuggestedskillsV3,
      data,
    },
    true
  );
};

const addSkillToIndustryRole = (id, type, data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.industryRoles + id + type,
      data,
    },
    true
  );
};

const addSkillToIndustryRoleV3 = (id, type, data) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.industryRolesV3}/${id}/${type}`,
      data,
    },
    true
  );
};

const addSkillToLeaderRole = (id, type, data) => {
  return API(
    {
      method: "POST",
      url: config.urls.auth.leadershipRoles + id + type,
      data,
    },
    true
  );
};

const addSkillToLeaderRoleV3 = (id, type, data) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.leadershipRolesV3}/${id}/${type}`,
      data,
    },
    true
  );
};

const getSkillCriticalityList = () => {
  return API(
    {
      method: "GET",
      url: config.urls.auth.skillCriticality,
    },
    true
  );
};

const getSkillCriticalityListV3 = () => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.skillCriticalityV3,
    },
    true
  );
};

//version2

const GetSkillTreeV2 = (id) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.getSkillTreeV2 + id,
    },
    true
  );
};

const SearchSkillV2 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.getSkillV2 + "/search",
      data,
    },
    true
  );
};

const CreateSkillTreeV2 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.createSkillTreeV2,
      data,
    },
    true
  );
};

//version3

const SearchSkillV3 = (data, sortBy = "skillName", sortOrder = "asc") => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.getSkillV3 + `/search?sortBy=${sortBy}&sortOrder=${sortOrder}`,
      data,
    },
    true
  );
};

const GetSkillTreeV3 = (id) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.getSkillTreeV3 + id,
    },
    true
  );
};

const CreateSkillTreeV3 = (parentSkillId, type, childSkillId) => {
  return APIV2(
    {
      method: "POST",
      url:
        config.urls.auth.createSkillTreeV3 +
        parentSkillId +
        type +
        childSkillId,
    },
    true
  );
};

const CreateSkillTreeWithoutIDV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.createSkillTreeV3,
      data,
    },
    true
  );
};

const DeleteSkillTreeV3 = (parentSkillId, type, childSkillId) => {
  return APIV2(
    {
      method: "DELETE",
      url:
        config.urls.auth.deleteSkillTreeV3 +
        parentSkillId +
        type +
        childSkillId,
    },
    true
  );
};

const GetEncyclopediaTypesV3 = (id) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.encyclopediaTypesList,
    },
    true
  );
};

const GetEncyclopediaV3 = (id, text, pageParam) => {
  return APIV2(
    {
      method: "GET",
      url:
        config.urls.auth.encyclopediaList + "/" + id + "/" + text + pageParam,
    },
    true
  );
};

const CreateDisprzopediaV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.disprzopedia,
      data,
      // onUploadProgress: function (progressEvent) {
      //   console.log(
      //     "progressEvent",
      //     progressEvent,
      //     progressEvent.loaded,
      //     progressEvent.total
      //     // progressEvent.currentTarget.onprogress((ev) => ev)
      //   );

      //   // Do whatever you want with the native progress event
      //   let percentCompleted = Math.round(
      //     (progressEvent?.loaded * 100) / progressEvent?.total
      //   );
      //   EventEmitter.dispatch("progress", percentCompleted);
      // },
    },
    true
  );
};

const GetDisprzopediaV3 = (data) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.disprzopedia + data,
    },
    true
  );
};

const EditDisprzopediaV3 = (id, data) => {
  return APIV2(
    {
      method: "PATCH",
      url: config.urls.auth.disprzopedia + id,
      data,
    },
    true
  );
};

const PostSampleContentDisprzopediaV3 = (id) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.disprzopediaMappingSample + id,
    },
    true
  );
};

const MappingSampleContentDisprzopediaV3 = (id) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.disprzopediaMappingSample + id,
    },
    true
  );
};

const MappingAllContentDisprzopediaV3 = (id) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.disprzopediaAllSample + id,
    },
    true
  );
};

const GetAssessmentsTypeV3 = (assessmentText) => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.assessments + "/" + assessmentText,
    },
    true
  );
};

const AddAssessmentV3 = (skillId, data) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.getSkillV3}/${skillId}/assessments`,
      data,
    },
    true
  );
};

const EditAssessmentV3 = (skillId, data, assessmentId) => {
  return APIV2(
    {
      method: "PATCH",
      url: `${config.urls.auth.getSkillV3}/${skillId}/assessments/${assessmentId}`,
      data,
    },
    true
  );
};

const DeleteAssessmentV3 = (skillId, assessmentId) => {
  return APIV2(
    {
      method: "DELETE",
      url: `${config.urls.auth.getSkillV3}/${skillId}/assessments/${assessmentId}`,
    },
    true
  );
};

const GenerateAssessmentV3 = (skillId) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.getSkillV3}/${skillId}/assessments/generate`,
    },
    true
  );
};

const publishEvaluations = (skillId) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.getSkillV3}/${skillId}/assessments/evaluations/publish`,
    },
    true
  );
}

const ExportAdaptiveAssessmentQuestions = (skillId) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.getSkillV3}/${skillId}/assessments/export`,
    },
    true
  );
};

const GetAiSkillWikiTagsV3 = (data) => {
   return APIV2(
    {
      method: "POST",
      url: config.urls.auth.wikisV3,
      data
    },
    true
   )
};

const GetAiSkillShortDescriptionSuggestionV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.skillDesctionSuggestionV3,
      data
    },
    true
  )
};

const GetAiSkillDetailedDescriptionSuggestionV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.skillDetailedDescriptionSuggestionV3,
      data
    },
    true
  )
}

const GetAiSkillLevelDescriptionSuggestionV3 = (data) => {
  return APIV2(
    {
      method: "POST",
      url: config.urls.auth.skillProficiencyLevelDescriptionSuggestionV3,
      data
    },
    true
  )
};

const GetClientSkillDataV3 = (personaId) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.personas}/${personaId}/skill-import`
    },
    true
  )
};

const getClientSkillsSuggestionGenerationStatus = (personaId) => {
  return APIV2(
    {
      method: "GET",
      url:`${config.urls.auth.personas}/${personaId}/skill-import/status`
    }
  );
};

const ImportClientSkillDataV3 = (personaId, data) => {
  return APIV2(
      {
        method: "POST",
        url: `${config.urls.auth.personas}/${personaId}/skill-import`,
        data
      },
      true
  )
};

const PartialSaveSkillDataV3 = (personaId, data) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.personas}/${personaId}/skill-import/partial-save`,
      data
    },
    true
  )
};

const SaveSkillDataV3 = (personaId) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.personas}/${personaId}/skill-import/complete`
    },
    true
  )
};

const AddSkillsToSkillListV3 = (personaId, data) => {
  return APIV2(
    {
      method: "POST",
      url: `${config.urls.auth.personas}/${personaId}/skill-mapping`,
      data
    },
    true
  )
};

const DeleteSkillFromSkillListV3 = (personaId, skillId, isIndustryRoleSkill) => {
  return APIV2(
    {
      method: "DELETE",
      url: `${config.urls.auth.personas}/${personaId}/skill-mapping?skillId=${skillId}&isIndustryRoleSkill=${isIndustryRoleSkill}`,
    },
    true
  )
}

const getSkillMappingTemplateUrlV3 = () => {
  return APIV2(
    {
    method: "GET",
    url: config.urls.auth.skillMappingTemplateV3
    },
    true
  )
}

const DeleteSkillProficiencyV3 = (personaId, proficiencyId ) => {
  return APIV2(
    {
      method: "DELETE",
      url: `${config.urls.auth.personas}/${personaId}/proficiency/${proficiencyId}`,
    },
    true
  )
}

const exportSkillDetailsV3 = (clientId, personaId, industryRoleId) => {
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.exportSkillDetailV3}/export?personaId=${personaId}&clientId=${clientId}&industryRoleId=${industryRoleId}`,
      responseType: 'blob'
    },
    true
  )
}

const newClientSkillDataV3 = (data) => {
   return APIV2(
     {
       method: "POST",
       url: `${config.urls.auth.newClientSkillDataV3}`,
       data
     },
     true
   )
}

const checkSkillExistsV3 = (name, excludeSkillId, sourceId) => {
  const params = new URLSearchParams({ name, excludeSkillId, sourceId });
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.checkSkillExistsV3}?${params.toString()}`
    },
    true
  );
}

const hasEvaluationAssessment = (skillId, proficiencyId) => {
  var url = `${config.urls.auth.hasEvaluationAssessmentV3.replace("{skillId}", skillId).replace("{proficiencyId}", proficiencyId)}`
  return APIV2({
      method: "GET",
      url: url
    },
    true
  );
}

const getProficiencySchemes = () => {
  return APIV2(
    {
      method: "GET",
      url: config.urls.auth.getProficiencySchemes,
    },
    true
  );
};

const createSkillProficienciesWithSchemeBulkAsync = (data,skillId) => {
   return APIV2(
     {
       method: "POST",
       url: `${config.urls.auth.createSkillProficienciesWithSchemeBulk.replace("{skillId}", skillId)}`,
       data
     },
     true
   )
}

const getSkillProficienciesWithSchemeBulkAsync = (skillId) => {
   return APIV2(
     {
       method: "GET",
       url: `${config.urls.auth.getSkillProficienciesWithSchemeBulkAsync.replace("{skillId}", skillId)}`,
     },
     true
   )
}

const updateSkillProficienciesWithSchemeBulkAsync = (data,skillId) => {
   return APIV2(
     {
       method: "PUT",
       url: `${config.urls.auth.updateSkillProficienciesWithSchemeBulk.replace("{skillId}", skillId)}`,
       data
     },
     true
   )
}

const checkSkillFamilyNameExistsAsyncV3 = (name, sourceId, excludeSkillCategoryId ) => {
  const params = new URLSearchParams({ name, sourceId, excludeSkillCategoryId });
  return APIV2(
    {
      method: "GET",
      url: `${config.urls.auth.checkSkillFamilyNameExistsV3}?${params.toString()}`
    },
    true
  );
}

const listQueryParamsForSkillAssessmentsV4 = new Set([
  "assessmentType",
  "assessmentSubType",
  "evaluator",
  "proficiencyLevel",
]);

const normalizeSkillAssessmentsV4Query = (...queryParts) => {
  const normalizedParams = new URLSearchParams();

  queryParts
    .filter(Boolean)
    .forEach((queryPart) => {
      const params = new URLSearchParams(String(queryPart).replace(/^[?&]/, ""));

      params.forEach((value, key) => {
        if (!listQueryParamsForSkillAssessmentsV4.has(key)) {
          normalizedParams.append(key, value);
          return;
        }

        value
          .split(",")
          .map((listValue) => listValue.trim())
          .filter(Boolean)
          .forEach((listValue) => normalizedParams.append(key, listValue));
      });
    });

  const normalizedQuery = normalizedParams.toString();
  return normalizedQuery ? `?${normalizedQuery}` : "";
};

const getSkillAssessmentsAsyncV4 = (
  skillId,
  type,
  pageSize = "",
  offset = "",
  sort = "",
  filter = "",
  proficiencySchemeLevelCount = ""
) => {
  return APIV2(
    {
      method: "GET",
      url:
        config.urls.auth.getSkillV4 +
        skillId +
        type +
        normalizeSkillAssessmentsV4Query(
          pageSize,
          offset,
          sort,
          filter,
          proficiencySchemeLevelCount
        )
    },
    true
  );
};

export const SkillService = {
  getSkillDetail,
  getSkillDetailV3,
  addSkillDetail,
  addSkillDetailV3,
  createFamilyV3,
  updateSkillDetail,
  updateSkillDetailV3,
  getSkillTypesArray,
  getSkillTypesArrayV3,
  updateSkillContentItem,
  bulkUpdateSkillContentItemV3,
  searchSkill,
  deleteSkillTypeItem,
  deleteSkillTypeItemV3,
  updateProficiency,
  updateProficiencyV3,
  getSkillCategories,
  getSkillCategoriesV3,
  getSkillFamilies,
  getSkillFamiliesV3,
  getSkillSources,
  getSkillSourcesV4,
  deleteSkillDetail,
  deleteSkillDetailV3,
  getSkillProficiencyLevels,
  getSkillProficiencyLevelsV3,
  addProficiency,
  addProficiencyV3,
  getSuggestedskills,
  getSuggestedskillsV3,
  addSkillToIndustryRole,
  addSkillToIndustryRoleV3,
  addSkillToLeaderRole,
  addSkillToLeaderRoleV3,
  getSkillContentItems,
  getSkillContentItemsV3,
  getSkillCriticalityList,
  getSkillCriticalityListV3,
  SearchSkillTree,
  SearchSkillV2,
  GetSkillTreeV3,
  CreateSkillTreeV2,
  CreateSkillTreeV3,
  CreateSkillTreeWithoutIDV3,
  GetSkillTreeV2,
  DeleteSkillTreeV3,
  SearchSkillV3,
  GetEncyclopediaTypesV3,
  GetEncyclopediaV3,
  CreateDisprzopediaV3,
  GetDisprzopediaV3,
  EditDisprzopediaV3,
  PostSampleContentDisprzopediaV3,
  MappingSampleContentDisprzopediaV3,
  MappingAllContentDisprzopediaV3,
  GetAssessmentsTypeV3,
  AddAssessmentV3,
  EditAssessmentV3,
  DeleteAssessmentV3,
  GenerateAssessmentV3,
  ExportAdaptiveAssessmentQuestions,
  GetClientSkillDataV3,
  ImportClientSkillDataV3,
  PartialSaveSkillDataV3,
  SaveSkillDataV3,
  GetAiSkillWikiTagsV3,
  GetAiSkillShortDescriptionSuggestionV3,
  GetAiSkillDetailedDescriptionSuggestionV3,
  GetAiSkillLevelDescriptionSuggestionV3,
  AddSkillsToSkillListV3,
  DeleteSkillFromSkillListV3,
  getSkillMappingTemplateUrlV3,
  DeleteSkillProficiencyV3,
  exportSkillDetailsV3,
  newClientSkillDataV3,
  checkSkillExistsV3,
  getClientSkillsSuggestionGenerationStatus,
  publishEvaluations,
  hasEvaluationAssessment,
  getProficiencySchemes,
  createSkillProficienciesWithSchemeBulkAsync,
  getSkillProficienciesWithSchemeBulkAsync,
  updateSkillProficienciesWithSchemeBulkAsync,
  checkSkillFamilyNameExistsAsyncV3,
  getSkillAssessmentsAsyncV4
};
